import { Component, OnDestroy, OnInit, inject } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';

import { MenuItems, SessionService } from '@core';

import { SpinnerModule } from '../../_shared/spinner/spinner.module';

@Component({
    templateUrl: './session-pending.component.html',
    imports: [TranslateModule, SpinnerModule]
})
export class SessionPendingComponent implements OnInit, OnDestroy {
    public sessionMissing = false;

    private static readonly SessionWaitMs = 15000;

    private readonly router = inject(Router);
    private readonly sessionService = inject(SessionService);

    private timeoutId: ReturnType<typeof setTimeout>;

    public ngOnInit(): void {
        if (this.sessionService.hasSession()) {
            this.router.navigateByUrl(
                `${MenuItems.routePlanner.path}/${MenuItems.routePlanner.children.planner.path}`
            );
            return;
        }
        this.timeoutId = setTimeout(() => (this.sessionMissing = true), SessionPendingComponent.SessionWaitMs);
    }

    public ngOnDestroy(): void {
        clearTimeout(this.timeoutId);
    }
}
